import * as Sentry from '@sentry/react'

const reportSentry = (
  e: string | Error | unknown,
  metadata: { severity?: Sentry.SeverityLevel; user?: object },
  tags?: { [key: string]: string | number | undefined },
) => {
  Sentry.withScope(function (scope) {
    scope.setLevel(metadata?.severity || 'error')

    if (metadata?.severity) delete metadata.severity

    if (metadata?.user) {
      scope.setUser(metadata.user)
      delete metadata.user
    }

    if (tags) {
      scope.setTags(tags)
    }

    scope.setContext('metadata', metadata)

    if (typeof e === 'string') {
      Sentry.captureMessage(e)
    } else {
      Sentry.captureException(e)
    }
  })
}

export const reportError = (
  e: string | Error | unknown,
  metadata: { severity?: Sentry.SeverityLevel; metaData?: unknown; user?: object } = {},
  tags?: { [key: string]: string | number | undefined },
) => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN

  if (SENTRY_DSN) {
    reportSentry(e, metadata, tags)
  } else {
    // This will log an error in an environment without sentry
    // eslint-disable-next-line no-console
    console.error(e, metadata, tags)
  }
}

export const registerAtomicTransaction = (name: string, tags?: { [key: string]: string | number | undefined }) => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN

  if (SENTRY_DSN) {
    Sentry.startTransaction({ name }, tags)?.finish()
  } else {
    // This will log an error in an environment without sentry
    // eslint-disable-next-line no-console
    console.error(name, tags)
  }
}

export const setReportUser = (id: number, email: string, workspace_id: number) => {
  Sentry.setUser({ id: String(id), email: email, workspace_id: workspace_id })
}

export class HttpError extends Error {
  statusCode: number
  constructor(message: string, statusCode: number) {
    super(message)
    this.statusCode = statusCode
  }
}
